<template>
  <div id="g-recaptcha" class="g-recaptcha" data-size="invisible" :data-sitekey="reCaptchaSiteKey" />
</template>

<script>
export default {
  props: {
    reCaptchaSiteKey: {
      type: String,
      default: '',
    },
  },
  methods: {
    execute() {
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(this.reCaptchaSiteKey)
            .then((token) => {
              if (token) {
                this.$emit('tokenSuccess', token);
              } else {
                this.$emit('tokenFailure');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },
  },
};
</script>
